import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const isAccepted = () => {
  try {
    return localStorage.getItem('acceptCookie') === 'accepted';
  } catch (e) {
    return false;
  }
};

const CookieNotification = () => {
  const { t } = useTranslation();
  // Читаем сразу, а не в эффекте: иначе баннер появляется на кадр (в пререндере его прячет класс cookie-accepted)
  const [isVisible, setIsVisible] = useState(() => !isAccepted());

  const acceptCookie = () => {
    try {
      localStorage.setItem('acceptCookie', 'accepted');
    } catch (e) {
      // localStorage недоступен (приватный режим) — баннер скрывается до перезагрузки
    }
    setIsVisible(false);
  };

  return isVisible &&
    <div className='cookie-notification'>
      <div className='cookie-notification__modal-wrapper'>
        <div className='cookie-notification__modal'>
          <div className='cookie-notification__modal-content'>
            <h2 className='cookie-notification__title'>{t('string.translate.cookie_title')}</h2>
            <div className='cookie-notification__text-wrapper'>
              <p className='cookie-notification__text'>
                {t('string.translate.cookie_subtitle')} {' '}
                <a
                  href='https://chernykh.tech/privacy-policy'
                  className='cookie-notification__link'
                  target='_blank'
                  rel='noreferrer'
                >
                  {t('string.translate.cookie_privacy')}
                </a>
              </p>
              <button
                className='cookie-notification__button'
                onClick={acceptCookie}
              >
                {t('string.translate.cookie_btn1')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};

export default CookieNotification;